var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 27.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 24.2381C21.458 26.2883 18.1605 27.5259 14.5574 27.5259C6.51756 27.5259 0 21.364 0 13.763C0 6.16189 6.51756 0 14.5574 0C18.1605 0 21.458 1.23763 24 3.28777C26.542 1.23763 29.8394 0 33.4426 0C41.4824 0 48 6.16189 48 13.763C48 21.364 41.4824 27.5259 33.4426 27.5259C29.8394 27.5259 26.542 26.2883 24 24.2381Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 24.2381C27.13 21.7138 29.1148 17.9575 29.1148 13.763C29.1148 9.56842 27.13 5.81215 24 3.28777C26.542 1.23763 29.8394 0 33.4426 0C41.4824 0 48 6.16189 48 13.763C48 21.364 41.4824 27.5259 33.4426 27.5259C29.8394 27.5259 26.542 26.2883 24 24.2381Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 24.2383C27.13 21.714 29.1147 17.9577 29.1147 13.7632C29.1147 9.56871 27.13 5.81247 24 3.28809C20.87 5.81247 18.8853 9.56871 18.8853 13.7632C18.8853 17.9577 20.87 21.714 24 24.2383Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.c198b5a711095a50ded51f88152b132f.svg";
export { ForwardRef as ReactComponent };